import { tns } from 'tiny-slider/src/tiny-slider.module';
import 'tiny-slider/dist/tiny-slider.css';
import './styles/tns_extensions.scss';

const TNS_DEFAULT_OPTIONS = {
  container: "#fixedWidth",
  fixedWidth: false,
  autoplay: false,
  autoplayTimeout: (10 * 1000),
  touch: true,
  mouseDrag: true,
  autoplayButton: false,
  speed: 1000,
  loop: false,
  edgePadding: 20,
  controlsText: [
    '<i class="fas fa-angle-left"></i>',
    '<i class="fas fa-angle-right"></i>',
  ],
  gutter: 10,
  items: 1,
  responsive: {
    320: {
      fixedWidth: 330,
      items: 1,
      edgePadding: 0,
    },
    480: {
      items: 2,
      edgePadding: 0,
    },
    768: {
      items: 2,
      edgePadding: 30,
    },
    992: {
      items: 3,
      edgePadding: 30,
    },
    1200: {
      fixedWidth: 305,
      items: 3,
      edgePadding: 50,
    },
  },
};

function showCarouselItems() {
  const $ = window.jQuery;
  $('.js-carousel-early-birds').each((i, carousel) => {
    const items = $(carousel).find('.js-carousel-early-birds-item');
    if (!items.length) { return; }
    for (let j = 0; j < items.length; j += 1) {
      setTimeout(() => {
        items[j].style.opacity = 1;
      }, j * 100);
    }
  });
}

// カルーセルのコンテナ要素のCSSセレクタを引数に与える
export function createTinySliderOptionsTop(containerElemSelector) {
  const options = Object.assign({}, TNS_DEFAULT_OPTIONS);
  options.container = containerElemSelector;
  return options;
}

export function initCarouselTop(options) {
  const $ = window.jQuery;
  if (window.carousels == null) {
    window.carousels = [];
  }
  const slider = tns(options);
  window.carousels.push(slider);
  showCarouselItems();
}

function initCarousels() {
  const $ = window.jQuery;
  $('.js-carousel-early-birds').each((i, carousel) => {
    if ($(carousel).children().length === 0) return;
    const id = $(carousel).attr('id');
    const maxItems = $(carousel).attr('data-max-items') || 3;
    const carouselOptions = createTinySliderOptionsTop(`#${id}`);
    carouselOptions.responsive[1200].items = Number(maxItems);
    initCarouselTop(carouselOptions);
  });
}

// Destroy carousel on this event
// Ref: https://m.phillydevshop.com/turbolinks-5-and-datatables-a882c29d6eff
document.addEventListener('turbolinks:before-cache', () => {
  if (window.carousels != null) {
    for (let i = 0; i < window.carousels.length; i += 1) {
      if (window.carousels[i].destroy) {
        window.carousels[i].destroy();
      }
    }
    window.carousels = [];
  }
});

document.addEventListener('turbolinks:load', () => {
  initCarousels();
});
